/* eslint-disable no-undef */
import axios from 'axios';
import Cookies from 'js-cookie';

export const getApiUrl = () => {
  if (process.env.VITE_NODE_ENV === 'development') {
    return 'http://localhost:5001/v1';
  }
  if (process.env.VITE_NODE_ENV === 'production') {
    return 'https://api.profoundpros.com/v1';
  }
};

export const getDomain = () => {
  if (process.env.VITE_NODE_ENV === 'development') {
    return 'localhost';
  }
  if (process.env.VITE_NODE_ENV === 'production') {
    return '.profoundpros.com';
  }
};

export const getAppUrl = (app) => {
  if (app === 'admin') {
    if (process.env.VITE_NODE_ENV === 'production') {
      return 'https://admin.profoundpros.com/';
    } else {
      return 'http://localhost:5174/';
    }
  }
  if (app === 'mega') {
    if (process.env.VITE_NODE_ENV === 'production') {
      return 'https://mega.profoundpros.com/';
    } else {
      return 'http://localhost:5175/';
    }
  }
};

// Token Cookie Management
export const getToken = () => {
  const token = Cookies.get('token');
  return token;
};

export const clearToken = () => {
  Cookies.remove('token', { domain: getDomain() });
};

// TenantId Cookie Management
export const getTenantId = () => {
  const tenantId = Cookies.get('tenantId');
  return tenantId;
};

export const setTenantId = (tenantId) => {
  Cookies.set(`tenantId`, tenantId, { domain: getDomain() });
};

export const clearTenantId = () => {
  Cookies.remove('tenantId', { domain: getDomain() });
};

export const useAuth = () => {
  axios.interceptors.request.use((config) => {
    config.headers['Authorization'] = `Bearer ${getToken()}`;
    // If its an admin route, tack on the tenantId
    if (config.url.includes('/v1/admin/')) {
      const tenantId = getTenantId();
      if (tenantId) {
        config.headers['tenantId'] = tenantId;
      }
    }
    return config;
  });
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (
        error.response.status === 401 &&
        window.location.pathname !== '/login'
      ) {
        clearToken();
        window.location.replace('/login');
        throw error;
      }
      throw error;
    }
  );
};

export const formatAndThrowApiError = (err) => {
  let errMessage = 'Something went wrong.';
  if (err.response?.status === 500) {
    errMessage = 'Something went wrong.';
  } else if (err.response?.data?.message) {
    errMessage = err.response.data.message;
  } else if (err.message) {
    errMessage = err.message;
  }
  throw Error(errMessage);
};
